import axios from "axios";

export const SHIPPINGS_URL =`${process.env.REACT_APP_API_URL}/shipping-carriers`;

export const RETURNED_REASONS_URL =`${process.env.REACT_APP_API_URL}/auxiliary/returned-reasons`;

export const GEO_URL =`${process.env.REACT_APP_API_URL}/geo`;

export const ORDERS_URL =`${process.env.REACT_APP_API_URL}/orders`;


export function getShippingCarriers(business_unit_id) {
  const params={businessUnitId:business_unit_id};
  return axios.get(SHIPPINGS_URL, {params});
}

export function getReturnedReasons() {
  return axios.get(RETURNED_REASONS_URL);
}


export function getStates() {
  return axios.get(GEO_URL + '/state');
}

export function getLocalities(params) {
  return axios.get(GEO_URL + '/locality',{ params });
}

export function postNewAddress(params) {
  return axios.post(ORDERS_URL + '/' + params.order_id + '/address', params.address);
}

